import * as yup from "yup";
import { ARABIC } from "../../../public/Constants/EnumConstants";

export const NEWSLETTER_SCHEMA_EN = yup.object({
    EmailSubscribe: yup
        .string()
        .email("Please Enter a Valid Email")
        .required("Please Enter Email Address"),
});

export const NEWSLETTER_SCHEMA_AR = yup.object({
    EmailSubscribe: yup
        .string()
        .email("يرجى إدخال البريد الإلكتروني الصحيح")
        .required("الرجاء إدخال عنوان البريد الإلكتروني"),
});
export const getFormSchema = (locale) => {
    return locale === ARABIC ? NEWSLETTER_SCHEMA_AR : NEWSLETTER_SCHEMA_EN;
};
export const DEFAULT_VALUES = {
    EmailSubscribe: "",
};
